import React, { useRef, useState } from "react"
import { Form, Button, Card, Alert, Container } from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { Link } from "react-router-dom"
import * as FaIcons from 'react-icons/fa';
import "../css/login.css"

export default function ChangePassword() {
  const emailRef = useRef()
  const { resetPassword } = useAuth()
  const [error, setError] = useState("")
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setMessage("")
      setError("")
      setLoading(true)
      await resetPassword(emailRef.current.value)
      setMessage("Check your inbox for further instructions")
    } catch {
      setError("Failed to reset password")
    }

    setLoading(false)
  }

  return (
    <Container id="container" className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <Card className="w-100 mt-2" id="card-container">

        <Card.Body>
          <h2 className="text-center mb-4">Password Reset</h2>

          {error && <Alert variant="danger">{error}</Alert>}
          {message && <Alert variant="success">{message}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" ref={emailRef} required />
            </Form.Group>
            <br/>
            <Button disabled={loading} className="w-100" type="submit">
              Reset Password
            </Button>
          </Form>

          <div className="w-100 mt-3" id="instructions">
            <p> Enter your email address to obtain a <strong> Password Reset <span>Link</span> </strong> for your Admin account. </p>
          </div>

          <div className="w-100 text-center mt-3">
            <Link className="back-link" to="/dashboard"> <FaIcons.FaAngleLeft/> Back</Link> 
          </div>

        </Card.Body>

      </Card>
    </Container>
  )
}
